import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import bannerSrc from "../assets/banner.jpg";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
  const { pathname } = useLocation();

  const items = [
    { to: "/", label: "Acasă" },
    { to: "/despre", label: "Despre" },
    { to: "/proiecte&programe", label: "Proiecte & Programe", special: true },
    {
      label: "Educație",
      children: [
        { to: "/inscrieri-clasa-pregatitoare", label: "Înscrieri clasa pregătitoare"},
        { to: "/tichete-sociale", label: "Tichete sociale"},
        { to: "/clase", label: "Clase" },
        { to: "/orar", label: "Orar" },
        { to: "/oferta-educationala", label: "Oferta Educațională" },
        { to: "/transfer-elevi", label: "Transfer Elevi" },
        { to: "/performanta-scolara", label: "Performanța Școlară" },
        { to: "/profesional", label: "Învățământ Profesional" },
        { to: "/consiliul-elevilor", label: "Consiliul elevilor"}
      ],
    },
    {
      label: "Documente",
      children: [
        { to: "/legislatie", label: "Legislație" },
        { to: "/publicatii", label: "Publicații" },
        { to: "/organigrama", label: "Organigramă" },
        { to: "/revista-scolii", label: "Revista Școlii" },
        { to: "/hotarariCA", label: "Hotărâri CA" },
        { to: "/autorizatii", label: "Autorizații"},
        { to: "/declaratii", label: "Declarații"},
        { to: "/surse-financiare", label: "Surse financiare"}
      ],
    },
    { to: "/resurse-umane", label: "Resurse Umane" },
    { to: "/anunturi", label: "Anunțuri" },
    { to: "/program-de-lucru", label: "Program de lucru" },
    { to: "/butonRosu/Buton rosu.pdf", label: "Buton roșu", pdf: true }
  ];

  const flatItems = items.flatMap((item) =>
    item.children ? item.children : [item]
  );
  const current = flatItems.find(
    ({ to }) => pathname === to || pathname.startsWith(to + "/")
  );
  const currentLabel = current?.label || "Meniu";

  useEffect(() => {
    setIsOpen(false);
    setOpenDropdown(null);
    setOpenMobileDropdown(null);
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <div className="w-full bg-gradient-to-r from-[rgb(220,240,180)] to-[rgb(170,190,107)]">
        <div className="max-w-7xl mx-auto">
          <img
            src={bannerSrc}
            alt='Liceul Tehnologic "Dr. Florian Ulmeanu"'
            className="w-full object-cover"
          />
        </div>
      </div>

      <nav className="sticky top-0 z-50 bg-gradient-to-r from-[rgb(220,240,185)] to-[rgb(170,190,107)] shadow-md py-3">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4">
          <span className="text-[rgb(0,51,51)] font-bold block lg:hidden">
            {currentLabel}
          </span>

          <ul className="hidden lg:flex ml-auto space-x-4 items-center">
            {items.map((item, idx) => {
              if (item.children) {
                const active = item.children.some((c) => c.to === pathname);
                return (
                  <li key={item.label} className="relative">
                    <button
                      onClick={() =>
                        setOpenDropdown(openDropdown === idx ? null : idx)
                      }
                      className={`px-4 py-1 rounded-md transition ${
                        active ? "bg-white text-[rgb(0,51,51)]" : ""
                      }`}
                    >
                      {item.label}
                      <span className="ml-1 inline-block">
                        {openDropdown === idx ? "▲" : "▼"}
                      </span>
                    </button>
                    {openDropdown === idx && (
                      <ul className="absolute right-0 mt-1 bg-white rounded shadow-lg">
                        {item.children.map((child) => (
                          <li key={child.to}>
                            <Link
                              to={child.to}
                              className={`block px-4 py-2 whitespace-nowrap text-[rgb(0,51,51)] hover:bg-gray-100 ${
                                pathname === child.to ? "font-semibold" : ""
                              }`}
                            >
                              {child.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              }

              if (item.pdf) {
                return (
                  <li key={item.to}>
                    <a
                      href={item.to}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-4 py-2 rounded-md bg-red-600 text-white font-semibold hover:bg-red-700 transition"
                    >
                      {item.label}
                    </a>
                  </li>
                );
              }

              const active = pathname === item.to;
              const baseClasses = "px-4 py-1 rounded-md transition";
              const activeClasses = active
                ? "bg-white text-[rgb(0,51,51)]"
                : item.special;
              return (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={() => setIsOpen(false)}
                    className={`${baseClasses} ${activeClasses}`}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>

          <button
            className="lg:hidden px-3 py-1 rounded-md bg-white text-[rgb(0,51,51)] shadow"
            onClick={() => setIsOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {isOpen ? "× Închide" : "☰ Meniu"}
          </button>
        </div>

        {isOpen && (
          <div className="lg:hidden border-t border-[rgb(0,51,51)]">
            <ul className="px-0 py-2 flex flex-col items-center space-y-2">
              {items.map((item, idx) => {
                if (item.children) {
                  const active = item.children.some((c) => c.to === pathname);
                  return (
                    <li key={item.label}>
                      <button
                        onClick={() =>
                          setOpenMobileDropdown(
                            openMobileDropdown === idx ? null : idx
                          )
                        }
                        className={`w-full flex justify-center items-center text-left px-4 py-2 rounded-md transition ${
                          active ? "bg-white text-[rgb(0,51,51)]" : ""
                        }`}
                      >
                        {item.label}
                        <span className="ml-1 inline-block">
                          {openMobileDropdown === idx ? "▲" : "▼"}
                        </span>
                      </button>
                      {openMobileDropdown === idx && (
                        <ul className="w-full flex flex-col items-center md:items-start pl-6 mt-1 space-y-1">
                          {item.children.map((child) => (
                            <li key={child.to}>
                              <Link
                                to={child.to}
                                onClick={() => setIsOpen(false)}
                                className={`block px-4 py-2 rounded-md transition hover:text-gray-200 ${
                                  pathname === child.to
                                    ? "bg-white text-[rgb(0,51,51)]"
                                    : ""
                                }`}
                              >
                                {child.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  );
                }

                const active = pathname === item.to;
                return (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      onClick={() => setIsOpen(false)}
                      className={`block text-center px-4 py-2 rounded-md transition text-black${
                        active ? " bg-white text-[rgb(0,51,51)]" : ""
                      }`}
                    >
                      {item.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </nav>
    </>
  );
}
